<template>
  <div id="ourservice">
    <section class="pt-20 pb-32 bg-white">
      <div class="px-20 mx-auto max-w-6xl">
        <h2 class="mb-1 text-3xl font-extrabold leading-tight text-gray-900">
          Our services
        </h2>
        <p class="mb-16 text-lg text-gray-500">
          below are the services we offer.
        </p>
        <div
          class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-16 lg:gap-x-24 gap-y-20"
          data-aos="fade-up"
          data-aos-duration="2000"
          data-aos-anchor-placement="center-bottom"
        >
          <div>
            <div
              class="flex items-center justify-center w-12 h-12 mb-4 text-red-600 bg-red-100 rounded-full"
            >
              <svg
                class="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                />
              </svg>
            </div>
            <h3
              class="mb-2 text-base font-semibold leading-tight text-gray-900 lg:text-lg"
            >
              Web Apps Developer
            </h3>
            <p class="text-sm text-gray-500 lg:text-base">
              we can make you a website to help develop your product or
              business.
            </p>
          </div>

          <div>
            <div
              class="flex items-center justify-center w-12 h-12 mb-4 text-green-600 bg-green-100 rounded-full"
            >
              <svg
                class="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                />
              </svg>
            </div>
            <h3
              class="mb-2 text-base font-semibold leading-tight text-gray-900 lg:text-lg"
            >
              Mobile Apps Developer
            </h3>
            <p class="text-sm text-gray-500 lg:text-base">
              we can make you a mobile application to help develop your product
              or business.
            </p>
          </div>
          <div class="">
            <div
              class="flex items-center justify-center w-12 h-12 mb-4 text-blue-600 bg-blue-100 rounded-full"
            >
              <svg
                class="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                />
              </svg>
            </div>
            <h3
              class="mb-2 text-base font-semibold leading-tight text-gray-900 lg:text-lg"
            >
              Custom Software Development
            </h3>
            <p class="text-sm text-gray-500 lg:text-base">
              we can make you a web or mobile application according to your
              wishes.
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {};
</script>
